module.exports = {
      id: "profile-usage",
      viewBox: "0 0 80 80",
      url: __webpack_public_path__ + "svg-sprite-a4f600bbb193d1259d8ec4877be13b3c.svg#profile",
      toString: function () {
        return this.url;
      }
    }